<ng-container *ngIf="params && values !== undefined && values !== null">
	<ng-container *ngFor="let value of values">
		<a
			*ngIf="value.routerLinkParams !== undefined else notALink"
			[routerLink]="value.routerLinkParams.commands"
			[fragment]="value.routerLinkParams.extras?.fragment"
			[preserveFragment]="value.routerLinkParams.extras?.preserveFragment || false"
			[queryParams]="value.routerLinkParams.extras?.queryParams"
			[queryParamsHandling]="value.routerLinkParams.extras?.queryParamsHandling"
			[relativeTo]="value.routerLinkParams.extras?.relativeTo"
			[replaceUrl]="value.routerLinkParams.extras?.replaceUrl || false"
			[skipLocationChange]="value.routerLinkParams.extras?.skipLocationChange || false"
			[state]="value.routerLinkParams.extras?.state"
			class="copo-datacenter-grid-link">{{ value.value }}
		</a>
		<br>
	</ng-container>
	<ng-template #notALink>
		{{ params.value }}
	</ng-template>
</ng-container>